import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-car-bloc-autopartage',
  templateUrl: './car-bloc-autopartage.component.html',
  styleUrls: ['./car-bloc-autopartage.component.scss']
})
export class CarBlocAutopartageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
